/* ============
 * Groups State
 * ============
 *
 * The state of the groups module.
 */

export default {
  pagination: {
    current: 1,
    total: 1,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/settings-groups/state.js